import { lazy } from "react";

export const PageAdminHome = lazy(() => import("./Container"));
